<template>
  <div class="container-fluid">
    <b-overlay
      :show="overlay_show"
      rounded="sm"
      variant="doorder-primary"
      opacity="0.5"
      blur="2px"
    >
      <b-card>
        <b-table-simple
          class="table table-no-bordered table-hover doorderTable"
          id="ordersTable"
          hover
          responsive
        >
          <b-thead>
            <b-tr>
              <b-th v-if="user_title == 'admin'"></b-th>
              <b-th>Date/Time</b-th>
              <b-th>Order Number</b-th>
              <b-th>Order Time</b-th>
              <b-th v-if="user_title == 'admin'">Retailer</b-th>
              <b-th>Status</b-th>
              <b-th>Deliverer</b-th>
              <b-th>Location</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="order in orders"
              :key="order.id"
              @click="clickViewOrderRow(order.id)"
            >
              <b-td class="select-checkbox" v-if="user_title == 'admin'">
                <input
                  type="checkbox"
                  name="selectedOrders[]"
                  v-bind:value="order.id"
              /></b-td>
              <b-td class="dateTimeTd">{{ order.created_at }}</b-td>
              <b-td>#{{ order.order_id }}</b-td>

              <b-td>{{ order.fulfilment_date }}</b-td>
              <b-td v-if="user_title == 'admin'">{{
                order.owner != null ? order.owner.name : ""
              }}</b-td>
              <b-td
                ><span :class="'orderStatusSpan ' + order.status + '_status'">
                  {{ getOrderStatusClassAndStr(order.status) }}
                </span></b-td
              >
              <b-td>{{
                order.operator != null ? order.operator.name : "N/A"
              }}</b-td>
              <b-td class="tablePinTd"
                ><span class="pinsSpan" :id="'locationSpan-' + order.id">
                  <!-- <i class="fas fa-map-marker-alt" style="color: #747474"></i> -->
                  <font-awesome-icon
                    icon="fa-sharp fa-solid fa-location-dot"
                    style="color: #747474"
                  />
                  <span
                    style="
                      width: 20px;
                      height: 0;
                      display: inline-block;
                      border-top: 2px solid #979797;
                    "
                  ></span>
                  <!-- <i
                  class="fas fa-map-marker-alt"
                  style="color: #60a244"
                ></i> --><font-awesome-icon
                    icon="fa-sharp fa-solid fa-location-dot"
                    style="color: #60a244"
                  />
                </span>
                <b-popover
                  :target="'locationSpan-' + order.id"
                  :container="'locationSpan-' + order.id"
                  triggers="hover"
                  placement="left"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-circle"
                    style="color: #747474"
                  />
                  {{ order.pickup }} <br />
                  <font-awesome-icon
                    icon="fa-solid fa-circle"
                    style="color: #60a244"
                  />
                  {{ order.location }}
                </b-popover>
                <!-- <b-tooltip
                  :target="'locationSpan-' + order.id"
                  :container="'locationSpan-' + order.id"
                  placement="left"
                  fallback-placement="counterclockwise"
                  :show="true" :no-fade="false"	
                >
                  Hello <strong>World!</strong> {{ order.id }}
                </b-tooltip> -->
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
      <!-- <button @click="clickAssignOrders">test</button> -->
      <b-row class="justify-content-center" v-if="user_title == 'admin'">
        <b-col lg="3" md="3" sm="4" class="text-center px-md-1">
          <b-button
            variant="doorder-primary"
            class="btn-bumblebee btn-doorder mx-auto"
            disabled
            @click="clickAssignOrders"
          >
            Assign orders
          </b-button>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>


<script>
import $ from "jquery";
import axios from "axios";
import { getOrderStatusClassAndStr } from "@/utils/helper-functions-doorder.js";

var table;
export default {
  name: "DoorderOrdersList",
  components: {},
  data() {
    return {
      user_title: JSON.parse(window.localStorage.getItem("user")),
      orders: [],
      table: null,
      overlay_show: false,
    };
  },

  mounted() {
    let user = JSON.parse(window.localStorage.getItem("user"));
    console.log(user);
    console.log(user.id, user.title);
    this.user_id = user.id;
    this.user_title = user.type;
    // this.getOrders(user.id);
    console.log(this.user_title);
    console.log(this.user_title);
    this.overlay_show = true;
    let temp = this;
    setTimeout(function () {
      temp.initTable();
      temp.getOrdersList();
    }, 1000);

    //
  },
  methods: {
    getOrderStatusClassAndStr,
    getOrdersList() {
      console.log("here call user list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);

      let params_request = "?orderBy=id&order=DESC";
      if (this.user_title == "user") {
        params_request = params_request + "&owner_id=" + this.user_id;
      }
      console.log(params_request);

      axios
        .get("/jobs/jobs" + params_request, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DOORDER",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          // console.log(table);
          // table.destroy();
          if (table != null) {
            table.destroy();
          }
          console.log(response);
          this.orders = response.data.data;
          // console.log(this.rowsData);
          var temp = this;
          setTimeout(function () {
            // console.log(table);
            // console.log(table == null);
            // if (table == null) {
            //   temp.initTable();
            // } else {
            // console.log(table.data());
            temp.initTable();
            // console.log(table.data());
            // table.destroy();
            // $('#sampleTable').DataTable().clear()
            // $('#sampleTable').DataTable().destroy()
            //
            // }
          }, 1000);
          temp.overlay_show = false;
          // table.ajax.reload()
        });
    },
    initTable() {
      let temp = this;
      if (this.user_title == "admin") {
        table = $("#ordersTable").DataTable({
          sDom: 'flti<"table_selected_rows">p',
          // sDom: 'flti<"table_selected_rows">p',
          // // buttons: [
          // //    'csv',
          // // ],
          ordering: false,
          info: true,
          destroy: true,
          responsive: true,
          // scrollY: "450px",
          scrollCollapse: true,
          searching: true,
          lengthMenu: [
            [10, 25, 50, 100],
            [10, 25, 50, 100],
          ],
          columnDefs: [
            {
              targets: -1,
              orderable: false,
            },
            {
              orderable: false,
              className: "select-checkbox",
              targets: 0,
            },
          ],
          select: {
            style: "multi",
          },
          pagingType: "full_numbers",
          language: {
            paginate: {
              previous: "<i class='fas fa-angle-left'></i>",
              next: "<i class='fas fa-angle-right'></i>",
              first: "<i class='fas fa-angle-double-left'></i>",
              last: "<i class='fas fa-angle-double-right'></i>",
            },
            search: "",
            searchPlaceholder: "Search ",
          },
        });
        $("#ordersTable tbody")
          .off()
          .on("click", "tr td:first-child", function () {
            // console.log(table.row(this).data());
            $(this).parent().toggleClass("selected");
            if ($(this).children().is(":checked")) {
              $(this).children().attr("checked", false);
            } else {
              $(this).children().attr("checked", "checked");
            }
            // console.log($('input[name="selectedOrders[]"]:checked'));

            let length_selected = table
              .rows()
              .nodes()
              .to$()
              .find('input[type="checkbox"]:checked').length;

            $(".table_selected_rows").html(
              length_selected + " row(s) selected"
            );
          });
      } else {
        table = $("#ordersTable").DataTable({
          sDom: 'flti<"table_selected_rows">p',
          ordering: false,
          info: true,
          destroy: true,
          responsive: true,
          scrollCollapse: true,
          searching: true,
          lengthMenu: [
            [10, 25, 50, 100, -1],
            [10, 25, 50, 100, "All"],
          ],
          columnDefs: [
            {
              targets: -1,
              orderable: false,
            },
          ],
          pagingType: "full_numbers",
          language: {
            paginate: {
              previous: "<i class='fas fa-angle-left'></i>",
              next: "<i class='fas fa-angle-right'></i>",
              first: "<i class='fas fa-angle-double-left'></i>",
              last: "<i class='fas fa-angle-double-right'></i>",
            },
            search: "",
            searchPlaceholder: "Search ",
          },
        });
      }
    },

    clickViewOrderRow(id) {
      console.log("click order view " + id);
      this.$router.push({ name: "DoorderViewOrder", params: { id } });
    },
    clickAssignOrders() {
      console.log("in click assign orders");
      $('input[name="selectedOrders[]"]:checked').each(function () {
        console.log($(this).val());
      });
      table
        .rows()
        .nodes()
        .to$()
        .find('input[type="checkbox"]:checked')
        .each(function () {
          console.log("  ", $(this), $(this).attr("checked"), $(this).val());
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/orders/lists/TableView.vue